import React from 'react';

interface SearchHighlightProps {
  text: string;
  searchTerm: string;
  className?: string;
}

export const SearchHighlight: React.FC<SearchHighlightProps> = ({
  text,
  searchTerm,
  className = ''
}) => {
  if (!searchTerm || !text) {
    return <span className={className}>{text}</span>;
  }

  try {
    // 将搜索词分割成多个关键词
    const keywords = searchTerm.split(/\s+/).filter(keyword => keyword.length > 0);

    if (keywords.length === 0) {
      return <span className={className}>{text}</span>;
    }

    // 创建包含所有关键词的正则表达式
    const escapedKeywords = keywords.map(keyword =>
      keyword.replace(/[.*+?^${}()|[\]\\]/g, '\\$&')
    );
    const regex = new RegExp(`(${escapedKeywords.join('|')})`, 'gi');
    const parts = text.split(regex);

    return (
      <span className={className}>
        {parts.map((part, index) => {
          // 检查这个部分是否匹配任何关键词
          const isMatch = keywords.some(keyword =>
            part.toLowerCase() === keyword.toLowerCase()
          );

          return isMatch ? (
            <mark
              key={index}
              className="bg-yellow-200 dark:bg-yellow-800 px-1 rounded text-gray-900 dark:text-gray-100"
            >
              {part}
            </mark>
          ) : (
            <span key={index}>{part}</span>
          );
        })}
      </span>
    );
  } catch (error) {
    return <span className={className}>{text}</span>;
  }
};
